<template>
<div class="table-container" ref="container">
  <div class="fixed-table">
    <table ref="target"></table>
  </div>
  <table>
    <thead ref="source">
      <tr>
        <th>日期</th>
        <th>{{spreadCommodity.variety1}}</th>
        <th>{{spreadCommodity.variety2}}</th>
        <th>价差</th>
      </tr>
    </thead>
    <tbody>
      <tr :key="item.date" v-for="item in list">
        <td>{{item.date || '-'}}</td>
        <td>{{getNum(item.price1)}}</td>
        <td>{{getNum(item.price2)}}</td>
        <td :class="{up: item.spread > 0, down: item.spread < 0}">{{getNum(item.spread)}}</td>
      </tr>
    </tbody>
  </table>
</div>
</template>
<script>
import { Sticky } from 'vant';
export default {
  name: 'SpreadTable',
  components: {
    [Sticky.name]: Sticky
  },
  props: {
    spreadCommodity:{
      type: Object,
      default: () => {
        return {
          'variety1': '',
          'variety2': ''
        }
      }
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  created(){
    window.addEventListener('scroll', this.onScroll)
  },
  methods: {
    getNum(num){
      return num ? num : (num === 0 ? 0 : '-')
    },
    onScroll(){
      if(!this.$refs.container){
        return;
      }
      const top = this.$refs.container.getBoundingClientRect().top;
      if(top < 0){
        const has = this.$refs.target.hasChildNodes();
        if(!has){
          this.insertHeader()
        }
      }else{
        this.$refs.target.innerHTML = '';
      }
    },
    insertHeader(){
      this.$refs.target.appendChild(this.$refs.source.cloneNode(true));
    }
  }
}
</script>
<style scoped>
.table-container .fixed-table{
  position: fixed;
  top: 0;
  left: .1rem;
  right: .1rem;
  z-index: 1;
}
.table-container{
  white-space: nowrap;
  padding: 0 .1rem;
}
.table-container th:nth-child(2) {
  transform: translateX(-.15rem);
  z-index: -1;
}
.table-container th:nth-child(3) {
  transform: translateX(.15rem);
  z-index: -1;
}
</style>